"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reservations = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const Info_1 = __importDefault(require("@mui/icons-material/Info"));
const material_1 = require("@mui/material");
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_router_dom_1 = require("react-router-dom");
const useProviderLogin_1 = __importDefault(require("../../../common/helpers/Hooks/useProviderLogin"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const withLazy_1 = __importDefault(require("../../../common/decorators/withLazy"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const helpers_1 = require("../../../common/helpers/helpers");
const TextField_1 = __importDefault(require("../FormFields/TextField"));
const Logo_1 = __importDefault(require("../../../common/components/Header/Logo"));
const KioskAppHeader_1 = __importDefault(require("../Header/KioskAppHeader"));
const DateAndTime = (0, withLazy_1.default)((0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require(/* webpackChunkName: "DateAndTime154745" */ '../FormFields/DateAndTime')))));
const Wrapper = styled_components_1.default.div `
  position: relative;
`;
const ContentWrapper = styled_components_1.default.div `
  padding: 10px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10vh;

  form {
    max-width: 520px;
  }
`;
const ErrorWrapper = styled_components_1.default.div `
  padding: 0 16px;
  @media (min-width: 840px) {
    padding: 0 24px;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  color: red;
  div:first-child {
    flex-basis: 20%;
    max-width: 45px;
    display: flex;
  }
`;
const UserStay = styled_components_1.default.div `
  padding: 16px;
  border: 1px solid #d5d5d5;
  border-radius: 15px;
  background: #fafafa;
  margin: 0 auto;

  .title {
    text-transform: uppercase;
    color: #919191;
    margin: 15px 0 10px 0;
  }

  .room-nr-and-type {
    display: flex;
    justify-content: space-between;
  }
`;
const NextStep = styled_components_1.default.div `
  padding: 16px 0;
  font-size: 1.2rem;
`;
const DateAndNumber = styled_components_1.default.div `
  display: flex;
  border-bottom: 1px solid #d5d5d5;
  align-content: center;
  justify-content: space-between;
  padding: 5px 0;
  margin-bottom: 5px;
`;
const OnlineCheckin = styled_components_1.default.div `
  padding: 16px;
  border: 1px solid #d5d5d5;
  border-radius: 15px;
  background: #fafafa;

  .headline {
    font-size: 1.2rem;
  }

  .text {
    margin: 15px 0;
  }
`;
const ButtonWrapper = styled_components_1.default.div `
  position: relative;
  padding: 16px 0;
  text-align: center;
  margin: 0 auto;
  max-width: 520px;
`;
const SearchFormLoadErrorWrapper = styled_components_1.default.div `
  text-align: center;
  padding: 16px;
`;
const Heading = styled_components_1.default.div `
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    height: 12vmin;
  }

  h2 {
    font-size: 4vmin;
    margin-bottom: 10px;
    color: #212121;
    font-weight: 400;
  }
`;
const Reservations = (props) => {
    const { currentLocale, userData, timezone, history, location, baseUrl, kioskModeEnabled, updateStore } = props;
    const [fields, setFields] = (0, react_1.useState)([]);
    const [isSubmitDisabled, setIsSubmitDisabled] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [searchFormLoadError, setSearchFormLoadError] = (0, react_1.useState)('');
    const [stay, setStay] = (0, react_1.useState)(null);
    const [submitError, setSubmitError] = (0, react_1.useState)('');
    const { isLoginRequired, loginUrl } = (0, useProviderLogin_1.default)(userData);
    const [texts, setTexts] = (0, react_1.useState)({
        registerBoxButton: '',
        registerBoxDelimiter: '',
        registerBoxHeadline: '',
        registerBoxText: '',
    });
    const [submitButtonText, setSubmitButtonText] = (0, react_1.useState)('');
    const [showDialog, setShowDialog] = (0, react_1.useState)(false);
    const [showInternetDialogError, setShowInternetDialogError] = (0, react_1.useState)(false);
    const [isInformationInFields, setIsInformationInFields] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        apiService_1.default.getSearchReservationForm(currentLocale, userData.token, kioskModeEnabled).then((data) => {
            if (data.status === 'success') {
                setSubmitButtonText(data.texts.submitButton);
                setFields(data.fields);
            }
            else {
                setSearchFormLoadError(data.message);
            }
            setIsLoading(false);
        });
    }, [props.userData]);
    (0, react_1.useEffect)(() => {
        const dirtyFields = fields.filter((field) => field.value && field.value !== 'NaN/NaN/NaN');
        setIsSubmitDisabled(dirtyFields.length < 2);
    }, [fields]);
    (0, react_1.useEffect)(() => {
        if (!kioskModeEnabled) {
            // using this to check if a checkin was already done on the account and then directing the user to the checkin balance page
            apiService_1.default
                .initializeCheckin(currentLocale, userData.token)
                .then((data) => {
                if (data.status === 'success' && data.screen === 'invoice') {
                    history.push({
                        pathname: `${baseUrl}/guest_journey/checkin/resume`,
                        state: { accountBalance: data },
                    });
                }
            })
                .catch(() => { });
        }
        const inKeycardActivationFromCheckin = location.state && location.state.inKeycardActivationFromCheckin;
        if (kioskModeEnabled && inKeycardActivationFromCheckin) {
            const keycardActivationStay = location.state && location.state.stay;
            const keycardActivationTexts = location.state && location.state.texts;
            updateStore('stayId', keycardActivationStay.id);
            setStay(keycardActivationStay);
            setTexts(keycardActivationTexts);
            setIsSubmitDisabled(false);
        }
    }, []);
    const formatDate = (date) => `${date.getFullYear()}/${date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}/${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}`;
    const handleArrivalChange = (activeField, selectedDate) => {
        setFields(fields.map((field) => {
            if (field.id === activeField.id) {
                return Object.assign(field, { value: selectedDate ? formatDate(new Date(selectedDate)) : null });
            }
            return field;
        }));
    };
    const handleLastNameChange = (activeField) => (event) => {
        setIsInformationInFields(true);
        setFields(fields.map((field) => {
            if (field.id === activeField.id) {
                return Object.assign(field, { value: event.target.value });
            }
            return field;
        }));
    };
    const handleSubmit = (event) => {
        var _a, _b;
        event.preventDefault();
        let internetConnectionError = false;
        if (!navigator.onLine) {
            internetConnectionError = true;
            setShowInternetDialogError(internetConnectionError);
            return;
        }
        setIsSubmitDisabled(true);
        const lastName = ((_a = fields.find((field) => field.id === 'last_name')) === null || _a === void 0 ? void 0 : _a.value) || '';
        const reservationId = ((_b = fields.find((field) => field.id === 'reservation_id')) === null || _b === void 0 ? void 0 : _b.value) || '';
        const token = kioskModeEnabled ? localStorage.getItem('kioskUserToken') : userData.token;
        const inKioskModeCheckout = location.state && location.state.inKioskModeCheckout;
        const inKeycardActivation = location.state && location.state.inKeycardActivation;
        if (inKeycardActivation) {
            apiService_1.default
                .retrieveKeycardReservation(currentLocale, token, reservationId, lastName, kioskModeEnabled)
                .then((data) => {
                if (data.status === 'error') {
                    setSubmitError(data.message);
                }
                else {
                    setStay(Object.assign({}, data.stay, {
                        roomTypes: [data.stay.keyCardRoomType],
                    }));
                    setTexts(data.texts);
                    setSubmitError('');
                    if (kioskModeEnabled) {
                        updateStore('stayId', data.stay.id);
                    }
                }
                setIsSubmitDisabled(false);
            });
            return;
        }
        if (inKioskModeCheckout) {
            apiService_1.default
                .retrieveCheckoutReservation(currentLocale, token, reservationId, lastName, kioskModeEnabled)
                .then((data) => {
                if (data.status === 'error') {
                    setSubmitError(data.message);
                }
                else {
                    setStay(data.stay);
                    setTexts(data.texts);
                    setSubmitError('');
                    if (kioskModeEnabled) {
                        updateStore('stayId', data.stay.id);
                    }
                }
                setIsSubmitDisabled(false);
            });
            return;
        }
        apiService_1.default
            .retrieveReservation(currentLocale, token, reservationId, lastName, kioskModeEnabled)
            .then((data) => {
            if (data.status === 'error') {
                setSubmitError(data.message);
            }
            else {
                setStay(data.stay);
                setTexts(data.texts);
                setSubmitError('');
                if (kioskModeEnabled) {
                    updateStore('stayId', data.stay.id);
                }
            }
            setIsSubmitDisabled(false);
        });
    };
    const renderDateAndReservationNumber = () => {
        if (stay) {
            const dateOptions = {
                month: 'short',
                day: 'numeric',
            };
            const startDate = helpers_1.Helpers.convertDateToTimezone(stay.startsOn, timezone, dateOptions);
            const endDate = helpers_1.Helpers.convertDateToTimezone(stay.endsOn, timezone, dateOptions);
            const year = helpers_1.Helpers.convertDateToTimezone(stay.endsOn, timezone, { year: 'numeric' });
            return (react_1.default.createElement(DateAndNumber, null,
                react_1.default.createElement("div", null,
                    startDate,
                    " - ",
                    endDate,
                    ", ",
                    year),
                react_1.default.createElement("div", null,
                    "Res: ",
                    stay.reservationId)));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    const renderGuests = () => {
        if (stay) {
            return stay.guestNames.map((guestName) => react_1.default.createElement("div", { key: guestName }, guestName));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    const renderRoomTypes = () => {
        if (stay) {
            return stay.roomTypes.map((room) => react_1.default.createElement("div", { key: room }, room));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    const goToOnlineCheckin = () => {
        const inKioskModeCheckout = location.state && location.state.inKioskModeCheckout;
        const inKeycardActivation = location.state && location.state.inKeycardActivation;
        const inKeycardActivationFromCheckin = location.state && location.state.inKeycardActivationFromCheckin;
        let internetConnectionError = false;
        if (!navigator.onLine) {
            internetConnectionError = true;
            setShowInternetDialogError(internetConnectionError);
            return;
        }
        if (stay && inKioskModeCheckout) {
            history.push({
                pathname: `${baseUrl}/payment_adyen_checkout`,
            });
            return;
        }
        if (stay && (inKeycardActivation || inKeycardActivationFromCheckin)) {
            history.push({
                pathname: `${baseUrl}/guest_journey/kiosk/keycard_activation_flow/activate_card`,
            });
            return;
        }
        if (stay) {
            history.push({
                pathname: `${baseUrl}/guest_journey/checkin/${stay.id}`,
            });
        }
    };
    const renderFormFields = () => fields.map((field) => {
        if (field.type === 'date') {
            return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
                react_1.default.createElement(DateAndTime, { fieldData: field, onChange: handleArrivalChange })));
        }
        return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
            react_1.default.createElement(TextField_1.default, { fieldData: field, onChange: handleLastNameChange })));
    });
    if (isLoginRequired && !kioskModeEnabled) {
        window.location.replace(loginUrl);
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (isLoading) {
        return react_1.default.createElement(Loader_1.default, { "data-testid": "loader-wrapper" });
    }
    if (searchFormLoadError) {
        return (react_1.default.createElement(Wrapper, { "data-testid": "form-load-error-wrapper" },
            react_1.default.createElement(SearchFormLoadErrorWrapper, null, searchFormLoadError)));
    }
    const kioskNavAction = () => {
        if (stay === null && isInformationInFields === false) {
            history.push({
                pathname: `${baseUrl}/guest_journey/kiosk`,
            });
            return;
        }
        if (history.location.pathname.includes('keycard_activation') || isInformationInFields) {
            setShowDialog(true);
            return;
        }
        history.push({
            pathname: `${baseUrl}/guest_journey/kiosk`,
        });
    };
    // eslint-disable-next-line consistent-return
    const handleDialogClick = (action) => {
        if (action === 'discard') {
            return history.push(`${baseUrl}/guest_journey/kiosk`);
        }
        setShowDialog(false);
    };
    return (react_1.default.createElement(Wrapper, { "data-testid": "reservations-wrapper" },
        react_1.default.createElement(react_1.default.Fragment, null,
            kioskModeEnabled && (react_1.default.createElement(KioskAppHeader_1.default, { title: i18n_js_1.default.t('api_guest_journey_my_reservations_title'), navAction: kioskNavAction })),
            !stay ? (react_1.default.createElement(ContentWrapper, null,
                kioskModeEnabled && (react_1.default.createElement(Heading, null,
                    react_1.default.createElement(Logo_1.default, null),
                    react_1.default.createElement("h2", null,
                        " ",
                        i18n_js_1.default.t('guest_journey_enter_reservation_details_kiosk'),
                        " "))),
                react_1.default.createElement("form", { onSubmit: handleSubmit, "data-testid": "form-wrapper" },
                    react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
                        renderFormFields(),
                        submitButtonText && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(material_1.Button, { size: "large", type: "submit", variant: "contained", fullWidth: true, disabled: isSubmitDisabled, "data-testid": "retrieve-reservation" }, submitButtonText)))),
                    submitError && (react_1.default.createElement(ErrorWrapper, null,
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(Info_1.default, null)),
                        react_1.default.createElement("div", null, submitError)))),
                react_1.default.createElement(material_1.Dialog, { "data-testid": "discard-form", open: showDialog, keepMounted: true, onClose: () => { }, "aria-describedby": "alert-dialog-slide-description" },
                    react_1.default.createElement(material_1.DialogTitle, null, i18n_js_1.default.t('close_form')),
                    react_1.default.createElement(material_1.DialogContent, null, i18n_js_1.default.t('guest_journey_kiosk_close_form_body')),
                    react_1.default.createElement(material_1.DialogActions, null,
                        react_1.default.createElement(material_1.Button, { onClick: handleDialogClick }, i18n_js_1.default.t('no_keyword_conflict_continue')),
                        react_1.default.createElement(material_1.Button, { "data-testid": "confirm-discard", onClick: () => handleDialogClick('discard') }, i18n_js_1.default.t('close_form')))),
                react_1.default.createElement(material_1.Dialog, { "data-testid": "internet-error", open: showInternetDialogError, keepMounted: true, onClose: () => { }, "aria-describedby": "alert-internet-connection-off " },
                    react_1.default.createElement(material_1.DialogTitle, null,
                        " ",
                        i18n_js_1.default.t('key_cards_internet_error'),
                        " "),
                    react_1.default.createElement(material_1.DialogContent, null,
                        " ",
                        i18n_js_1.default.t('key_cards_internet_dialog_content'),
                        " "),
                    react_1.default.createElement(material_1.DialogActions, null,
                        react_1.default.createElement(material_1.Button, { onClick: () => history.push(`${baseUrl}/guest_journey/kiosk`) },
                            " ",
                            i18n_js_1.default.t('ok'),
                            " "))))) : (react_1.default.createElement(ContentWrapper, null,
                react_1.default.createElement("div", { "data-testid": "stay-wrapper", className: kioskModeEnabled ? 'kiosk-view' : '' },
                    kioskModeEnabled && (react_1.default.createElement(Heading, null,
                        react_1.default.createElement(Logo_1.default, null),
                        react_1.default.createElement("h2", null,
                            " ",
                            i18n_js_1.default.t('guest_journey_your_reservation_details_kiosk')))),
                    react_1.default.createElement(UserStay, null,
                        renderDateAndReservationNumber(),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: "title" }, i18n_js_1.default.t('guests')),
                            renderGuests()),
                        react_1.default.createElement("div", { className: "room-nr-and-type" },
                            stay.roomNumber && (react_1.default.createElement("div", null,
                                react_1.default.createElement("div", { className: "title" }, i18n_js_1.default.t('api_guest_journey_stay_room_number')),
                                react_1.default.createElement("div", null, stay.roomNumber))),
                            stay.roomTypes && (react_1.default.createElement("div", null,
                                react_1.default.createElement("div", { className: "title" }, i18n_js_1.default.t('room_type')),
                                renderRoomTypes())))),
                    !kioskModeEnabled && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(NextStep, null, texts.registerBoxDelimiter),
                        react_1.default.createElement(OnlineCheckin, null,
                            react_1.default.createElement("div", { className: "headline" }, texts.registerBoxHeadline),
                            react_1.default.createElement("div", { className: "text" }, texts.registerBoxText),
                            react_1.default.createElement(ButtonWrapper, null,
                                react_1.default.createElement(material_1.Button, { fullWidth: true, variant: "contained", size: "large", onClick: goToOnlineCheckin, "data-testid": "go-to-checking" }, texts.registerBoxButton))))),
                    kioskModeEnabled && (react_1.default.createElement(ButtonWrapper, null,
                        react_1.default.createElement(material_1.Button, { fullWidth: true, variant: "contained", size: "large", onClick: goToOnlineCheckin, "data-testid": "go-to-checkin" }, texts.registerBoxButton)))),
                react_1.default.createElement(material_1.Dialog, { "data-testid": "discard-form", open: showDialog, keepMounted: true, onClose: () => { }, "aria-describedby": "alert-dialog-slide-description" },
                    react_1.default.createElement(material_1.DialogTitle, null, i18n_js_1.default.t('close_form')),
                    react_1.default.createElement(material_1.DialogContent, null, i18n_js_1.default.t('guest_journey_kiosk_close_form_body')),
                    react_1.default.createElement(material_1.DialogActions, null,
                        react_1.default.createElement(material_1.Button, { onClick: handleDialogClick }, i18n_js_1.default.t('no_keyword_conflict_continue')),
                        react_1.default.createElement(material_1.Button, { "data-testid": "confirm-discard", onClick: () => handleDialogClick('discard') }, i18n_js_1.default.t('close_form')))),
                react_1.default.createElement(material_1.Dialog, { "data-testid": "internet-error", open: showInternetDialogError, keepMounted: true, onClose: () => { }, "aria-describedby": "alert-internet-connection-off " },
                    react_1.default.createElement(material_1.DialogTitle, null,
                        " ",
                        i18n_js_1.default.t('key_cards_internet_error'),
                        " "),
                    react_1.default.createElement(material_1.DialogContent, null,
                        " ",
                        i18n_js_1.default.t('key_cards_internet_dialog_content'),
                        " "),
                    react_1.default.createElement(material_1.DialogActions, null,
                        react_1.default.createElement(material_1.Button, { onClick: () => history.push(`${baseUrl}/guest_journey/kiosk`) },
                            " ",
                            i18n_js_1.default.t('ok'),
                            " "))))))));
};
exports.Reservations = Reservations;
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
    timezone: store.getValue('timezone'),
    baseUrl: store.getValue('baseUrl'),
    kioskModeEnabled: store.getValue('kioskModeEnabled'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.Reservations));
